<div class="grid grid-cols-12">
  <div
    class="col-span-12 xl:col-span-8 xl:col-start-3 2xl:col-span-6 2xl:col-start-4">
    <mat-stepper
      [@.disabled]="true"
      [scrollTop]="true"
      labelPosition="bottom"
      [linear]="true"
      #stepper>
      <ng-template matStepperIcon="edit">
        <mat-icon class="material-symbols-rounded scale-125">done</mat-icon>
      </ng-template>

      <!-- Step 1: School details -->
      <mat-step
        [stepControl]="schoolForm"
        [editable]="getCurrentStep() !== 1"
        label="Schule erstellen">
        <div class="pt-10">
          <strong class="block font-bold text-2xl md:text-4xl mb-2">
            Schule erstellen
          </strong>
          <p class="text-bn-bright text-base mb-6">
            Gib den Namen und die Art deiner Schule an.
          </p>

          <form [formGroup]="schoolForm">
            <div class="flex flex-col gap-4">
              <mat-form-field class="w-full">
                <mat-label>Name der Schule</mat-label>
                <input matInput formControlName="name" />
                <mat-error>Gib einen Schulnamen ein.</mat-error>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Schulart</mat-label>
                <mat-select formControlName="schoolType">
                  @for (type of schoolTypes; track type.value) {
                    <mat-option [value]="type.value">
                      {{ type.label }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>Wähle eine Schulart aus.</mat-error>
              </mat-form-field>
            </div>

            @if (createError) {
              <p class="text-red-500 text-sm mt-2">{{ createError }}</p>
            }

            <app-secondary-button
              class="block w-fit ml-auto mr-0 mt-12"
              (onClick)="onSubmit()"
              [disabled]="isCreating">
              @if (isCreating) {
                <mat-spinner diameter="20" />
              } @else if (subscriptionType === 'SCHOOL_S') {
                Weiter zur Zahlung
              } @else {
                Schule erstellen
              }
            </app-secondary-button>
          </form>
        </div>
      </mat-step>

      <!-- Step 2: Confirmation -->
      <mat-step label="Bestätigung">
        <app-ordering-confirmation
          [subscriptionType]="subscriptionType"
          [emailAddress]="''"
          (closeDialog)="onCloseDialog()"></app-ordering-confirmation>
      </mat-step>
    </mat-stepper>
  </div>
</div>
